import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { APP_BASE } from "./config";
import { AppConfigProvider } from "./context/AppContext";
import { AppLayoutProvider } from "./context/AppLayoutContext";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import I18nProvider from "./i18n/I18nProvider";
import "./index.css";
import AppRoutes from "./routes/AppRoutes";

export default function App() {
  const queryClient = new QueryClient();
  return (
    <BrowserRouter basename={APP_BASE}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider>
            <AppConfigProvider>
              <I18nProvider>
                <AppLayoutProvider>
                  <AppRoutes />
                </AppLayoutProvider>
                <ToastContainer />
              </I18nProvider>
            </AppConfigProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
